'use es6';

import * as AppContext from './AppContext';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import createObjectValuesPropType from 'ecosystem-marketplace-core/constants/propTypes/createObjectValuesPropType';
export const appContext = createObjectValuesPropType(AppContext);
export const requestState = createObjectValuesPropType(RequestState);